import { SocialMediaPlatform } from "../types/influencer";

const PLATFORM_URL_BUILDERS: Record<string, (handle: string) => string> = {
  [SocialMediaPlatform.Instagram]: (handle) =>
    `https://www.instagram.com/${handle}`,
  [SocialMediaPlatform.YouTube]: (handle) =>
    `https://www.youtube.com/@${handle}`,
  [SocialMediaPlatform.LinkedIn]: (handle) =>
    `https://www.linkedin.com/in/${handle}`,
  [SocialMediaPlatform.TikTok]: (handle) =>
    `https://www.tiktok.com/@${handle}`,
};

export function getSocialMediaUrl(
  platform?: string,
  username?: string
): string | undefined {
  if (!username) return undefined;

  const trimmed = username.trim();
  if (!trimmed) return undefined;

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const handle = trimmed.replace(/^@+/, "");
  if (!handle) return undefined;

  const builder = platform ? PLATFORM_URL_BUILDERS[platform] : undefined;
  return builder ? builder(handle) : undefined;
}
